import { API } from 'service/API'

import { IBillingEntityJSON } from './BillingEntitiesModel'

export class BillingEntitiesService {
  API: API

  constructor(api: API) {
    this.API = api
  }

  getList = (): Promise<IBillingEntityJSON[]> => {
    return this.API.network.billingEntities.getBillingEntities()
  }
}
